<template>
  <router-link
    v-if="navigationItem"
    v-disableable="{blur: blurMenuItem(navigationItem), dim: dimMenuItem(navigationItem), disabled: disableMenuItem(navigationItem) }"
    :to="navigationItem.route"
    :class="{mastery: mastery, mobile: mobile, resourceActive: active, pulse: pulseMenuItem(navigationItem)}"
    @click.native="menuItemClicked(navigationItem)"
  >
    <div class="icon-container">
      <icon
        v-if="!mastery && navigationItem.webIcon"
        :name="navigationItem.webIcon"
        variant="white"
      />
    </div>
    <div class="name">
      {{ navigationItem.name }}
    </div>
  </router-link>
</template>

<script>
import Icon from '@components/singletons/icon';

import GlobalMixin from '@/mixins/global';

export default {
  components: { Icon },
  mixins: [GlobalMixin],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disableable: {
      type: Boolean,
      default: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    navigationItem: {
      type: Object,
    },
    onTour: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    mastery() {
      return this.$store.getters['app/isMasteryApp'];
    },
  },
  methods: {
    blurMenuItem(item) {
      if (!this.onTour) return false;
      return this.$route.name !== 'search#topic';
    },
    dimMenuItem(item) {
      if (!this.onTour) return false;
      return !(this.$route.name === 'search#topic' && this.$store.getters['session/tourSequence'] === 4 && item.destination === 'bookmarks');
    },
    disableMenuItem(item) {
      if (!this.onTour) return false;
      return !(this.$route.name === 'search#topic' && this.$store.getters['session/tourSequence'] === 4 && item.destination === 'bookmarks');
    },
    menuItemClicked(item) {
      this.$store.commit('session/toggleMobileMenu', false);
      const navGroup = this.$store.getters['navigationGroups/navigationGroups'][item.navigationGroupId];
      this.$analytics.events.selectedNavItem(item, navGroup, null);
    },
    pulseMenuItem(item) {
      if (!this.onTour) return false;
      return this.$route.name === 'search#topic' && this.$store.getters['session/tourSequence'] === 4 && item.destination === 'bookmarks';
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: rem-calc(4);
  min-height: rem-calc(37);

  > * {
    opacity: 0.4;
  }

  &:hover {
    background-image: linear-gradient(to bottom, #2F3845, #252C35);
  }

  &.pulse {
    animation: blue-pulse 1.5s infinite;
  }

  &.resourceActive {
    background-image: linear-gradient(-180deg, rgba(81,97,115,.48) 3%, rgba(59,72,87,.48) 98%);

    > * {
      opacity: 1;
    }
  }

  &.mastery:not(.mobile) {
    &:hover {
      background: transparent;
    }

    .name {
      color: black;
      font-weight: $normal;
      opacity: 1;
    }

    &.resourceActive {
      background: transparent;
      box-shadow: none;

      .name {
        color: black;
        font-weight: $bold;
        text-shadow: none;
      }
    }
  }

  &.mobile {
    .name {
      font-size: rem-calc(14);
    }
  }

  .icon-container {
    padding: rem-calc(10) rem-calc(12) rem-calc(11) rem-calc(12);

    img {
      height: rem-calc(16);
      width: rem-calc(16);
    }
  }

  .name {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    color: white;
    font-size: rem-calc(12);
    font-weight: $semi-bold;
    min-width: rem-calc(144);
    text-align: left;
  }
}
</style>
